import { ChangeDetectorRef, Component, inject, OnInit, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';
import { CouchSyncService } from './services/couch-sync.service';
import AuthService from './services/auth.service';
import { finalize } from 'rxjs';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, CommonModule],
  templateUrl: './app.html',
  styleUrl: './app.css',
  standalone: true,
})
export class App implements OnInit {
  protected auth = inject(AuthService);
  protected readonly title = signal('euroclean-pwa');
  private swUpdate = inject(SwUpdate);
  protected couchSync = inject(CouchSyncService);
  private cdr = inject(ChangeDetectorRef);
  public token = signal<string | null>(null);
  constructor() {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates.subscribe((evt) => {
        if (evt.type === 'VERSION_READY') {
          if (confirm('Une nouvelle version est disponible. Charger ?')) {
            window.location.reload();
          }
        }
      });
    }
  }
  ngOnInit(): void {
    const u = this.auth.currentUser;
    if (this.couchSync['globalLoadingSubject']) {
      this.couchSync['globalLoadingSubject'].next(true);
    }
    if (u) {
      this.auth
        .fetchMe(u.token)
        .pipe(
          finalize(() => {
            console.log('sync: checking for sectors');
            this.couchSync.startFullSync(
              { sectors: u?.sectors, username: u?.email, uuid: u?.uuid },
              u?.token,
            );
          }),
        )
        .subscribe({
          next: (res) => {
            this.auth.setUser({
              email: res.email,
              uuid: res.uuid,
              token: u.token,
              sectors: res.sectorsDbNames,
              name: res.name,
            });
          },
        });
    }
  }
}
